import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3;
import { jsx, jsxs } from 'react/jsx-runtime';
import { theme as theme$1, utils, Grid } from '@dls/web';
import styled from 'styled-components';
import AppVersion from './AppVersion.js';
import theme from '../../../../theme/index.js';
import '../../../../../../authentication/context/AuthenticationProvider.js';
import { DEFAULT_FOOTER_LOGO_URL } from '../../../../../../authentication/helpers/constants.js';
import '@geit/ui-components';
import 'react';
import { useAppConfig } from '../../../../../../authentication/hooks/useAppConfig.js';
import 'qs';
import 'uuid';
import '../../../../../../authentication/navigate.js';
const logoUrl = DEFAULT_FOOTER_LOGO_URL;
function EmpowerFooter(_ref) {
  let {
    appVersion
  } = _ref;
  const {
    appUrl
  } = useAppConfig();
  let logo = logoUrl;
  if (appUrl) {
    if (!logoUrl.startsWith("http")) {
      logo = "".concat(appUrl).concat(logoUrl);
    }
  }
  return /* @__PURE__ */jsx(FooterContainer, {
    id: "footer",
    children: /* @__PURE__ */jsx(Grid, {
      fluid: false,
      children: /* @__PURE__ */jsxs(FooterContent, {
        children: [/* @__PURE__ */jsx("a", {
          href: "/terms-and-conditions",
          target: "blank",
          rel: "noreferrer",
          className: "item",
          children: "TERMS & CONDITIONS"
        }), /* @__PURE__ */jsx("a", {
          href: "https://www.singtel.com/copyright",
          target: "_blank",
          rel: "noreferrer",
          className: "item",
          children: "COPYRIGHT"
        }), /* @__PURE__ */jsxs("div", {
          children: [/* @__PURE__ */jsx("div", {
            className: "item",
            children: /* @__PURE__ */jsx("span", {
              children: "\xA9 Singtel (CRN: 199201624D) All Rights Reserved."
            })
          }), /* @__PURE__ */jsx("img", {
            className: "logo",
            src: logo,
            alt: "logo",
            title: "Singapore Telecommunications Limited"
          }), appVersion && /* @__PURE__ */jsx(AppVersion, {
            version: appVersion
          })]
        })]
      })
    })
  });
}
const FooterContainer = styled.footer(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-top: 1px solid ", ";\n  background-color: ", ";\n"])), theme.colours.grey_d0, theme$1.main.colours.white);
const media = utils.createMediaQueries({
  xs: "0em",
  sm: theme$1.breakpoints.xs,
  md: theme$1.breakpoints.sm,
  lg: theme$1.breakpoints.md,
  xl: theme$1.breakpoints.lg,
  xxl: theme$1.breakpoints.xl
});
const FooterContent = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  min-height: 65px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  & > a {\n    text-decoration: none;\n    font-weight: 350;\n    font-size: 14px;\n    line-height: 28px;\n    text-transform: uppercase;\n    color: ", ";\n  }\n\n  & > div {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n    flex: 1;\n    text-align: right;\n  }\n\n  span {\n    color: ", ";\n    font-weight: 350;\n    font-size: 14px;\n    line-height: 28px;\n  }\n\n  .logo {\n    width: 129px;\n    margin-right: 24px;\n    display: none;\n    margin-left: 15px;\n  }\n\n  ", "\n"])), theme.colours.grey_97, theme.colours.grey_97, media.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    flex-direction: row;\n\n    .logo {\n      display: block;\n    }\n\n    & > a {\n      margin-right: 24px;\n      font-size: 16px;\n    }\n\n    span {\n      font-size: 16px;\n    }\n  "]))));
export { EmpowerFooter as default };